<template>
    <div class="map-center">
        碳减排量
        <div
            v-for="(item, i) in number"
            :key="'output' + i"
            class="number">
            {{ item }}
        </div>
        CC
    </div>
</template>

<script>
import { dataInterface } from '@/api/dataInterfaceApi'
export default {
    data() {
        return {
            number: ''
        }
    },
    mounted() {
        this.tanjianpai()
    },
    methods: {
        // 累计充换电站数量
        tanjianpai() {
            let params = {
                "enCode": "TiDB-Energy-quanguo-tanjianpai"
            }
            dataInterface
                .dataFaceApi(params)
                .then((res) => {
                    console.log('=========', res)
                    if(!res || !res.length || !res[0]) return
                    // resolve(res[0])
                    this.number = res[0].carbonEmissions
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    }
}
</script>

<style lang="scss" scoped>
.map-center {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    .number {
        background: url(~@/assets/images/energyMuseum/number.png) no-repeat;
        background-size: 100% 100%;
        width: 36px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #00FDF4;
        margin: 0 5px;
    }
}
</style>